@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

.Table {
  @extend %font-family-primary;
  border-spacing: 0;
  border-collapse: collapse;
  width: 100%;
  background-color: $theme-color-table-header-background;
  box-sizing: border-box;

  border td,
  th {
    padding: 10px;
    box-sizing: border-box;
  }

  th {
    font-weight: $font-weight-semibold;
    font-style: normal;
    text-align: left;
    color: $theme-color-text;
    padding: 12px 16px;
    background: $theme-color-table-header-background;
    font-size: 14px;
    white-space: nowrap; // Fix on resizeObserver loop limit error
  }

  td {
    font-size: $font-size-normal;
    padding: 18px 16px;
    vertical-align: top;
  }

  td:last-child {
    padding: 18px 8px;
  }

  th:last-child {
    padding: 18px 8px;
  }

  tbody>tr {
    color: $theme-color-text;
    background: $theme-color-background;
  }

  tr:not(:first-child) {
    border-top: 1px solid $color-secondary-button-border;
  }

  tr:hover {
    background-color: $theme-color-table-hover;
  }

  &.Compact {
    tr {
      border: none;
    }

    td {
      padding: 0;
    }

    th {
      border: none;
      font-size: $font-size-normal;
      padding: 0;
      font-weight: $font-weight-normal;
      background: none;
    }
  }
}